export default __webpack_public_path__ + "img/17904939463f19ede252f6f6eb394431.png";